<template>
  <div class="wrap">
    <div class="logo">
      <img src="@/assets/new/login/logo.png" alt="">
    </div>
    <div class="top_title">
      <div class="title3">{{ $t('注册') }}</div>
    </div>
    <div class="form_bar">
      <div class="inputs">
        <div v-for="(item, index) in formList" :key="index" class="input_item">
          <div class="_item">
            <img :src="item.icon" alt="">
            <input :type="item.type" :placeholder="$t(item.placeholder)" :maxlength="item.length"
              v-model="form[item.key]" :adjust-position="true" />
            <i class="iconfont pwd_icons" v-if="item.key === 'password' || item.key === 'againPassword'"
              :class="item.flag === true ? 'icon-yanjing' : 'icon-yanjing-bi'" @click="handleLookPass(index)"></i>
          </div>
        </div>
      </div>
      <div class="btn_login" @click="handleConfirm">{{ $t("login.register") }}</div>
      <div class="tips">
        <div class="tips_title">{{ $t('login.alreadyAccount') }}</div>
        <div class="tips_btn" @click="handleClose">{{ $t('login.title') }}</div>
      </div>
    </div>
    <div class="lan_bar" v-if="verConfig.loginSetLans" @click.stop="switchLansShow = true">
      <img src="@/assets/mine/lang.png" alt="">
    </div>
    <van-action-sheet v-model="switchLansShow" :actions="lans" :cancel-text="$t('user.Button.One')"
      :description="$t('切换语言')" close-on-click-action @select="checkLans" />
    <LoadingRE :show="LoadingShow" />
    <Popup :show="true" position="bottom">
      <Picker show-toolbar :columns="[JsonData]" :value-key="'zh'" :confirm-button-text="$t('user.Button.Two')"
        :cancel-button-text="$t('user.Button.One')" />
    </Popup>
  </div>
</template>

<script>
import {
  Row,
  Col,
  Icon,
  Cell,
  GridItem,
  Grid,
  NavBar,
  ActionSheet,
  Button,
  Toast,
  Checkbox,
  Popup,
  Picker,
  Field,
} from "vant";

import JsonData from "@/components/areaCodePicker/data.json";
import AreaCodePicker from "@/components/areaCodePicker";
import { mapGetters } from "vuex";
// 设置vant的多语言
import md5 from "js-md5";
import Cookies from "js-cookie";
import { Locale } from "vant";
import enUS from "vant/lib/locale/lang/en-US";
import Modelu from "@/utils/Module";
import antiShake from "@/utils/anti-shake";
import { getNewPhone } from "@/utils/tools";

import { SEND_SMS_CODE, LOGIN } from "@/api";
import LoadingRE from "@/components/LoadingRE";
import LoginType from "@/components/loginType";
import CurrencyPicker from "@/components/currencyPicker";
import SetLans from "@/components/setLans";
import i18n from "@/i18n";
import verConfig from "@/utils/verConfig";
import { getLanguage, setLan, setLanguage, lans } from "../../i18n";


const phoneItem = {
  placeholder: 'login.phoneNumber',
  icon: require("@/assets/new/login/phone.png"),
  type: "tel",
  key: "phone",
  flag: false,
  require: true,
  length: 11,
  onlyEmeil: true,
};
const emailItem = {
  label: `${i18n.t("Login.Daftar.email")}`,
  icon: require("@/assets/new/login/email.png"),
  type: "text",
  key: "email",
  flag: false,
  require: true,
  length: 99,
  onlyEmeil: true,
};

const fromidItem = {
  label: `${i18n.t("Login.Daftar.referrer")}`,
  icon: "icon-yaoqing",
  type: "text",
  key: "referrer",
  flag: false,
  require: true,
  length: 99,
};

const _currentLoginType = () => {
  if (verConfig.onlyEmailLogin) {
    return "email";
  }
  return "phone";
};

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [NavBar.name]: NavBar,
    [ActionSheet.name]: ActionSheet,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    LoadingRE,
    Popup,
    Picker,
    AreaCodePicker,
    CurrencyPicker,
    LoginType,
    SetLans,
  },
  data() {
    return {
      userAgreementChecked: this.verConfig.banDefaultRead ? false : true,
      formList: [
        phoneItem, {
          placeholder: "login.password",
          icon: require("@/assets/new/login/pwd.png"),
          type: "password",
          key: "password",
          flag: false,
          require: true,
          length: 99,
        }, {
          placeholder: "login.confirmPassword",
          icon: require("@/assets/new/login/pwd.png"),
          type: "password",
          key: "againPassword",
          flag: false,
          require: true,
          length: 99,
        }, {
          placeholder: "login.fromid",
          icon: require("@/assets/new/login/invite.png"),
          type: "text",
          key: "fromid",
          flag: false,
          require: true,
          length: 99,
        }],
      areaShow: false,
      areaCode: "",
      JsonData,
      country: Cookies.get("language"),
      LoadingShow: false,
      form: {
        phone: "",
        code: "112233",
        password: "",
        againPassword: "",
        fromid: ""
      },
      value1: 0,
      isSendCodeClick: true,
      auth_time: 0,
      codeImg: "",
      showflag1: false,
      showflag2: false,
      selectTittle: "",
      switchLansShow: false,
      lans:lans
    };
  },
  created() {
    this.setFromId();
    let storePwdState = localStorage.getItem("the-pwd-state");
    let storePwd = localStorage.getItem("the-pwd-obj");
    this.$cookie.clear();
    this.$cookie.set("the-pwd-state", storePwdState);
    this.$cookie.set("the-pwd-obj", storePwd);
  },
  computed: {
    loginType() {
      let value = localStorage.getItem('loginType') || 'phone'
      switch (value) {
        case "phone":
          this.formList.splice(0, 1, phoneItem);
          break;
        case "email":
          this.formList.splice(0, 1, emailItem);
          break;
        default:
          break;
      }
      return value
    },
    ...mapGetters(["theme"])
  },
  methods: {
    checkLans(actions, index) {
      if (actions.value === getLanguage()) {
        this.switchLansShow = false;
        return;
      }
      this.$i18n.Locale = actions.value;
      this.changeLanguage(actions.value);
      setLanguage(actions.value);
    },
    toService() {
      this.$api.toService();
    },
    handleLookPass(index) {
      if (this.formList[index].type === "password") {
        this.formList[index].type = "text";
        this.formList[index].flag = true;
      } else {
        this.formList[index].type = "password";
        this.formList[index].flag = false;
      }
    },
    handleClose() {
      this.form = {
        uesrName: "",
        code: "",
        password: "",
        againPassword: "",
      };
      this.$router.push({ name: "login" });
    },
    handleConfirm() {
      if (!this.form.phone) return Toast(this.$t('login.phoneNumberPlaceholder'));
      if (!this.form.password) return Toast(this.$t('login.passwordPlaceholder'));
      if (!this.form.againPassword) return Toast(this.$t('login.confirmPasswordPlaceholder'));
      if (this.form.password !== this.form.againPassword) return Toast(this.$t("login.pwdInconformity"));
      this.register();
    },
    register() {
      let item = {
        userphone: this.form.phone,
        userpass: this.form.password,
        code: this.form.code,
        fromid: this.form.fromid,
      };
      this.$store.dispatch("login", item);
    },
    setFromId() {
      let fromid = this.$route.query.id || this.$route.query.fromid;
      if (fromid) {
        this.$cookie.set("fromid", fromid);
        this.form.fromid = fromid
      }
    },
  },
};
</script>

<style lang="less" scoped>
@checkbox-label-color: #88888d;
@Color: var(--theme);
@background: var(--bg);
@bg: var(--bg);
@sizeColor: var(--sizeColor);
@newbgColor: #272a29;

.wrap {
  min-height: calc(100vh - 40rem / 16);
  padding: calc(20rem / 16) calc(10rem / 16);
  background: var(--bgImg) no-repeat;
  background-size: cover;

  .logo {
    width: 50%;
    margin: 0 auto;

    img {
      width: 100%;
      display: block;
    }
  }

  .top_title {
    margin-top: calc(-10rem / 16);
    padding-bottom: calc(15rem / 16);

    .title3 {
      font-size: calc(42rem / 16);
      color: var(--white);
      font-weight: 700;
      text-align: center;
      text-shadow: 5px 5px 8px #030913;
    }
  }

  .form_bar {
    padding: 0 calc(15rem / 16);

    .inputs {
      .input_item {
        margin: calc(15rem / 16) 0 0;
        padding: 0;

        ._item {
          border-radius: 5px;
          background-color: var(--white);
          padding: 0 calc(10rem / 16);
          display: flex;
          align-items: center;
          img{
            width: 24px;
          }
          input {
            flex: 1;
            border: 0;
            padding: 0;
            padding-left: calc(10rem / 16);
            font-size: calc(14rem / 16);
            height: calc(48rem / 16);
            line-height: calc(48rem / 16);
            background-color: transparent;
            color: @Color;
          }

          input:placeholder {
            font-size: calc(14rem / 16);
            color: var(--inputPlaceholder);
          }
        }
      }
    }

    .btn_login {
      margin: calc(35rem / 16) 0 calc(10rem / 16);
      background: var(--newbtnColor);
      color: var(--btnsizeColor);
      border-radius: calc(8rem / 16);
      height: calc(60rem / 16);
      font-size: calc(16rem / 16);
      text-align: center;
      font-weight: bold;
      line-height: calc(60rem / 16);
    }

    .tips {
      margin-top: calc(20rem / 16);
      font-size: calc(14rem / 16);
      color: var(--white);
      text-align: center;
      display: flex;
      align-items: baseline;
      justify-content: center;

      &_title {
        margin-bottom: calc(10rem / 16);
      }

      &_btn {
        text-decoration: underline;
        font-weight: 700;
        font-size: calc(20rem / 16);
      }
    }
  }

  .lan_bar {
    position: absolute;
    top: 6px;
    right: 6px;
    img{
      width: 30px;
      height: 30px;
    }
  }
}
</style>
